import type { PrescriptionType } from "@/lib/validations/medical-prescription";

export interface PrescriptionProfileFields {
  crmv_state?: string | null;
  crmv_number?: number | null;
  mapa_number?: string | null;
  address?: string | null;
}

export interface ProfileValidationResult {
  isValid: boolean;
  missingFields: Array<"CRMV" | "MAPA" | "address">;
  needsCRMV: boolean;
  needsMAPA: boolean;
  needsAddress: boolean;
}

const hasText = (value: string | null | undefined) => Boolean(value?.trim());

export function validatePrescriptionProfile(
  profile: PrescriptionProfileFields | null | undefined,
  prescriptionType: PrescriptionType,
  controlRegime?: string,
): ProfileValidationResult {
  if (!profile) {
    return {
      isValid: false,
      missingFields: [],
      needsCRMV: false,
      needsMAPA: false,
      needsAddress: false,
    };
  }

  const isIssuedByAkuna = prescriptionType === "standard" || prescriptionType === "manipulated" || prescriptionType === "exam";
  const needsCRMV = isIssuedByAkuna && (!hasText(profile.crmv_state) || !profile.crmv_number || profile.crmv_number <= 0);
  const needsAddress = isIssuedByAkuna && !hasText(profile.address);
  const needsMAPA = prescriptionType === "manipulated" && !hasText(profile.mapa_number);
  const missingFields: Array<"CRMV" | "MAPA" | "address"> = [];

  if (needsCRMV) missingFields.push("CRMV");
  if (needsMAPA) missingFields.push("MAPA");
  if (needsAddress) missingFields.push("address");

  return {
    isValid: missingFields.length === 0,
    missingFields,
    needsCRMV,
    needsMAPA,
    needsAddress,
  };
}
